import { render, staticRenderFns } from "./receiptCreate.vue?vue&type=template&id=132ae2e4&scoped=true&lang=html&"
import script from "./receiptCreate.vue?vue&type=script&lang=js&"
export * from "./receiptCreate.vue?vue&type=script&lang=js&"
import style0 from "./receiptCreate.vue?vue&type=style&index=0&id=132ae2e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ae2e4",
  null
  
)

export default component.exports